export const dateFormat = 'D MMM YYYY, HH:mm';
export const dateOnlyFormat = 'D MMM YYYY';
export const dateTimeFormat = 'YYYY-MM-DDTHH:mm';
export const dateFormatYearMonthDay = 'YYYY-MM-DD';
export const localDateFormat = 'LLL';
